export const getUniqueId = () => {
    let date = new Date().getTime();
    const uniqueId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (el: string) => {
        const rem = (date + Math.random() * 16) % 16 | 0;
        date = Math.floor(date / 16);
        return (el === 'x' ? rem : (rem & 0x3) | 0x8).toString(16);
    });

    return uniqueId;
};

export const arrayMove = (arr: any, oldIndex: number, newIndex: number) => {
    if (newIndex >= arr.length) {
        let i = newIndex - arr.length + 1;
        while (i--) {
            arr.push(undefined);
        }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
};
